import { TranslateLoader } from '@ngx-translate/core';
import { ConfigInitializerService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';

// AoT requires an exported function for factories
export function HybrisTranslateLoaderFactory(
  configInitializerService: ConfigInitializerService,
  occEndpointsService: OccEndpointsService,
  http: HttpClient
) {
  return new HybrisTranslateLoader(configInitializerService, occEndpointsService, http);
}

export class HybrisTranslateLoader implements TranslateLoader {
  constructor(
    private configInitializerService: ConfigInitializerService,
    private occEndpointsService: OccEndpointsService,
    private http: HttpClient
  ) {}

  getTranslation(language: string): Observable<any> {
    return this.configInitializerService.getStable('backend.occ').pipe(
      switchMap(() => {
        const url = this.occEndpointsService.buildUrl('translations', { urlParams: { language } });
        return this.http.get(url);
      })
    );
  }
}
